module.exports = __webpack_public_path__ + "static/media/LOADER_04.6edab24f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading_page/LOADER_04.png
// module id = 312
// module chunks = 0